/* Safari до 15.4 (macOS Big Sur и старше) не знает structuredClone — без замены конструктор падал в белый экран */
if (typeof globalThis.structuredClone !== 'function') (globalThis as any).structuredClone = (v: unknown) => (v === undefined ? v : JSON.parse(JSON.stringify(v)));
import './fonts';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initSession, installDropdowns, loadCounters } from '@tg/app-core';
import './styles';
import { App } from './App';
import { installFocusLock } from './shell/Mobile';
import { TrainerData } from './offline/Provider';

initSession('trainer');
installFocusLock();
installDropdowns();
createRoot(document.getElementById('root')!).render(
  <TrainerData>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </TrainerData>,
);
/* Service worker — кабинет открывается без сети (sw/sw.ts); в разработке не нужен */
if (import.meta.env.PROD && 'serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {});
/* Коды счётчиков из админки (Метрика, Mixpanel…) — после первого показа */
loadCounters('trainer');
